const cards = [
  {
    title: '知名美食博主深夜直播翻车',
    status: '已核实',
    img: 'https://readdy.ai/api/search-image?query=Food%20influencer%20livestreaming%20disaster%20on%20phone%20screen%2C%20dramatic%20pink%20and%20dark%20lighting%20contrast%2C%20messy%20table%20scene%2C%20editorial%20photography%2C%20moody%20atmosphere%2C%20internet%20drama%20aesthetic&width=800&height=500&seq=cards-01&orientation=landscape',
    featured: true,
  },
  {
    title: '某顶流男星酒店密会神秘女子',
    status: '追踪中',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20lobby%20at%20night%20with%20two%20distant%20figures%2C%20paparazzi%20style%20shot%2C%20pink%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20celebrity%20gossip%20aesthetic&width=800&height=500&seq=cards-02&orientation=landscape',
    featured: false,
  },
  {
    title: '百万粉穿搭博主全身假货被扒',
    status: '已核实',
    img: 'https://readdy.ai/api/search-image?query=Fashion%20items%20scattered%20on%20dark%20floor%20with%20magnifying%20glass%2C%20counterfeit%20goods%20investigation%20aesthetic%2C%20pink%20and%20dark%20mood%20lighting%2C%20editorial%20photography%2C%20dramatic%20composition&width=800&height=500&seq=cards-03&orientation=landscape',
    featured: false,
  },
  {
    title: '选秀节目冠军内定实锤曝光',
    status: '深度追踪',
    img: 'https://readdy.ai/api/search-image?query=Empty%20talent%20show%20stage%20with%20trophy%20in%20spotlight%2C%20dark%20surroundings%2C%20corruption%20metaphor%2C%20pink%20and%20amber%20dramatic%20lighting%2C%20editorial%20photography%2C%20revealing%20secrets%20aesthetic&width=800&height=500&seq=cards-04&orientation=landscape',
    featured: false,
  },
  {
    title: '网红情侣甜蜜人设一夜崩塌',
    status: '已核实',
    img: 'https://readdy.ai/api/search-image?query=Cracked%20heart%20shape%20on%20dark%20background%20with%20pink%20fragments%2C%20social%20media%20relationship%20drama%20aesthetic%2C%20emotional%20breakup%20visual%2C%20editorial%20photography%2C%20moody%20atmosphere%2C%20abstract%20composition&width=800&height=500&seq=cards-05&orientation=landscape',
    featured: false,
  },
  {
    title: '知名导演片场霸凌新人证据流出',
    status: '独家爆料',
    img: 'https://readdy.ai/api/search-image?query=Empty%20film%20director%20chair%20under%20harsh%20single%20spotlight%20on%20dark%20set%2C%20intimidation%20atmosphere%2C%20pink%20and%20shadow%20contrast%2C%20editorial%20photography%2C%20film%20industry%20dark%20side%2C%20dramatic%20lighting&width=800&height=500&seq=cards-06&orientation=landscape',
    featured: false,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          精选吃瓜现场
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl overflow-hidden cursor-pointer group hover:shadow-md transition-shadow duration-300">
              <div className="aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 text-center">
                <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
                <span className="inline-block text-xs font-semibold text-primary-500 mb-3">{item.status}</span>
                <div>
                  {item.featured ? (
                    <button className="px-6 py-2 bg-foreground-950 text-white text-xs font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer" type="button">
                      立即查看
                    </button>
                  ) : (
                    <button className="px-6 py-2 border border-foreground-300 text-foreground-700 text-xs font-semibold rounded-full hover:border-foreground-700 transition-all duration-200 whitespace-nowrap cursor-pointer" type="button">
                      查看详情
                    </button>
                  )}
                </div>
                <p className="text-[10px] text-foreground-400 mt-2">51每日大赛 · 独家报道</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}